<script lang="ts" setup>
import { inject, nextTick, ref } from "vue"
import { v4 as uuidv4 } from "uuid"

interface ComponentProps {
  option?: any
  data: { name: string; value: number }[]
}

const props = withDefaults(defineProps<ComponentProps>(), {
  option: () => ({
    visualMap: undefined,
  }),
  data: () => [],
})

const updateSeries = inject("updateSeries") as any
const map = inject("map") as any

const mapConfig = ref({
  id: uuidv4(),
  type: "map",
  map,
  label: {
    show: true,
  },
  data: [] as any[],
})

const mapOpt: any = {}

if (props.option.visualMap) {
  mapOpt.visualMap = Object.assign(
    {
      show: true,
      min: 800,
      max: 50000,
      text: ["High", "Low"],
      realtime: false,
      calculable: true,
      inRange: {
        color: ["lightskyblue", "yellow", "orangered"],
      },
    },
    props.option.visualMap,
  )
}

const setData = (opt: { data: { name: string; value: number }[] }) => {
  mapConfig.value.data = opt.data
  updateSeries(mapConfig.value, mapOpt)
}

nextTick(() => {
  setData(props)
})

defineExpose({
  setData,
})
</script>
